<!-- 营业执照 -->
<template>
    <div v-if="componentsData.type == 9" :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;`" >
        <img class="wh100" v-if="companyData.show_license" :src="companyData.show_license"
            :style="componentsData.content.version ?
                `border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;` :
                `border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`
            "        
        />
        <div class="none-div" v-else>请上传营业执照</div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        companyData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.wh100 {
    width: 100%;
    height: 148.8px;
    display: block;
    object-fit: cover;
}
.none-div {
    font-size: 14px;
    color: #808080;
}
</style>